// extracted by mini-css-extract-plugin
export default {"orderPrice":"DetailViewPayment_orderPrice__t517T","paymentCard":"DetailViewPayment_paymentCard__aAak5"};